export function AllowanceSettingsPage () {
  return (
    <div className='p-6'>
      <h2 className='heading-md'>Allowances</h2>
    </div>
  )
}
